import axios from "@/axios"
import * as types from '../mutation-types'

export default {
    namespaced: true,

    state: {
        holidays: []
    },

    actions: {
        fetch({ commit }) {
            return axios.get('settingsHr/holiDay').then(({data}) => {
                commit(types.STORE_HOLIDAY, data)
                return data
            }) 
        },

        create({ commit }, { durationInDays, date, startDate, reason, forAllEmployee, jobDescriptionIds, employeeIds }) {
            return axios.post('settingsHr/holiDay', { durationInDays, date, startDate, reason, forAllEmployee, jobDescriptionIds, employeeIds }).then((data) => {
                return data
            })
        },

        update({ commit }, { id, durationInDays, date, startDate, reason, forAllEmployee, jobDescriptionIds, employeeIds }) {
            return axios.put(`settingsHr/holiDay/${id}`, { durationInDays, date, startDate, reason, forAllEmployee, jobDescriptionIds, employeeIds }).then((data) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`settingsHr/holiDay/${id}`)
        }
    },

    mutations: {
        [types.STORE_HOLIDAY](state, holidays) {
            state.holidays = holidays
        }
    },

    getters: {
        getHolidayById: state => id => state.holidays.find(c => c.id === id)
    }
}